import { react } from "../../omnia"
import { TerramapContext } from "../context"
import { State } from "../state"

type Options = State["layerViewerOptions"]
import Checkbox = react.Checkbox

interface Props {
    options: Options
}

export function LayerViewerOptions({ options }: Props) {

    const { dispatch } = React.useContext(TerramapContext)

    const set = (update: Partial<Options>) => dispatch({ type: "setLayerViewerOptions", update })

    const [opacity, setOpacity] = useOpacity(options.opacity, opacity => set({ opacity }))

    return <div className="section grey layer-viewer-options">

        <react.Slider min={0} max={100} value={opacity} setValue={setOpacity} />

        <Checkbox
            checked={options.points}
            setChecked={points => set({ points })}
        >
            Show points<br /><span className="text-muted">(selected field only)</span>
        </Checkbox>

    </div>
}

function useOpacity(initial: number, set: (value: number) => void) {

    const s = React.useState(initial)

    // Using this to avoid calling dispatch directly during the change event handling,
    // as this seems to break the slider
    // Should probably try to implement this directly in the slider, maybe using requestAnimationFrame()?
    react.useDebouncedValueWithSetter(s[0], 15, set)

    return s

}
